"use client";

import { ParallelOutlet } from "@rangojs/router/client";
import { VariantProvider, useVariant, type VariantProduct } from "./VariantProvider.js";

function AttributeButtons() {
  const { product, selected, setSelected } = useVariant();

  if (!product.variationAttributes?.length) return null;

  return (
    <>
      {product.variationAttributes.map((attr) => {
        const selectedValue = selected[attr.id];
        return (
          <div key={attr.id} className="mt-6">
            <p className="mb-2 text-sm font-medium text-slate-700">
              {attr.name}
              {selectedValue && (
                <span className="ml-2 font-normal text-slate-500">
                  {attr.values?.find((v) => v.value === selectedValue)?.name ?? selectedValue}
                </span>
              )}
            </p>
            <div className="flex flex-wrap gap-2">
              {attr.values?.map((val) => (
                <button
                  key={val.value}
                  type="button"
                  onClick={() => setSelected(attr.id, val.value)}
                  className={
                    selected[attr.id] === val.value
                      ? "rounded border-2 border-slate-900 px-3 py-1 text-sm font-medium text-slate-900"
                      : "rounded border border-slate-300 px-3 py-1 text-sm text-slate-700 hover:border-slate-500"
                  }
                >
                  {val.name ?? val.value}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </>
  );
}

/** Variant selector layout — provides context, renders attribute buttons + children */
export function VariantSelectorLayout({
  product,
  initialSelected,
}: {
  product: VariantProduct;
  initialSelected?: Record<string, string>;
}) {
  return (
    <VariantProvider product={product} initialSelected={initialSelected}>
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="grid gap-8 lg:grid-cols-2">
          <ParallelOutlet name="@gallery" />
          <div>
            <ParallelOutlet name="@content" />
            <AttributeButtons />
            <ParallelOutlet name="@buyForm" />
          </div>
        </div>
      </div>
    </VariantProvider>
  );
}
